
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/immigration",
      function () {
        return require("private-next-pages/immigration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/immigration"])
      });
    }
  